import { Suspense, ReactNode } from 'react'
import LoadingAnimation from './LoadingAnimation'

interface LazyWrapperProps {
  children: ReactNode
  fallback?: ReactNode
}

const DefaultFallback = () => (
  <div className="flex items-center justify-center min-h-[200px] bg-background">
    <LoadingAnimation size="md" />
  </div>
)

export const LazyWrapper = ({ children, fallback = <DefaultFallback /> }: LazyWrapperProps) => {
  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  )
}

export default LazyWrapper
